export default __webpack_public_path__ + "static/media/image.b00cf07d.png";